/* eslint-disable @typescript-eslint/no-explicit-any */

import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table'
import { v4 as uuidv4 } from 'uuid'
import { Skeleton } from '@radix-ui/themes'

interface ITravelTableProps {
  columns: any
  data: any
  loading: boolean
  sortColumn?: string | undefined
  sortOrder?: string | undefined
  sortFunction?: (column: string) => void
}

function TravelTable(props: ITravelTableProps) {
  const { columns, data, loading, sortFunction, sortColumn, sortOrder } = props

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  })

  return (
    <>
      {data && !loading && (
        <div className="h-auto min-h-[110px] max-h-[calc(100vh_-_240px)] overflow-y-auto border border-mainBorder border-collapse rounded-lg">
          <table className="w-full table-fixed">
            <thead
              className="h-[56px] border-mainBorder border-b bg-tableHeaderGrey headerClass"
              style={{
                position: 'sticky',
                top: 0,
                zIndex: 1,
              }}
            >
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={uuidv4()} className="text-left h-[56px]">
                  {headerGroup.headers.map((header) => (
                    <th
                      key={uuidv4()}
                      className={`font-normal text-sm  ${headerGroup.headers[0] ? 'pl-4' : 'pl-2'} ${header.column.getCanSort() && sortFunction ? 'cursor-pointer' : ''}`}
                      onClick={() => {
                        header.column.getCanSort() && sortFunction ? sortFunction(header.column.id) : null
                      }}
                      style={{
                        width: header.getSize(),
                      }}
                    >
                      <div className="items-center flex">
                        {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                        <span className="p-1">
                          {header.column.id === sortColumn ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                        </span>
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.map((row) => (
                <tr key={uuidv4()} className="h-14 border-mainBorder border-b last:border-b-0 !bg-tableRowGrey">
                  {row.getVisibleCells().map((cell) => (
                    <td
                      key={uuidv4()}
                      className={`text-sm ${row.getVisibleCells()[0] ? 'pl-4' : 'pl-2'}`}
                      style={{
                        maxWidth: '300px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {(!data || loading) && (
        <div className="flex justify-center items-center mt-20">
          <Skeleton className="h-[300px] w-full flex-grow" />
        </div>
      )}
    </>
  )
}

export default TravelTable
